import { render, staticRenderFns } from "./question_popup.vue?vue&type=template&id=a853b520&scoped=true&"
import script from "./question_popup.vue?vue&type=script&lang=js&"
export * from "./question_popup.vue?vue&type=script&lang=js&"
import style0 from "./question_popup.vue?vue&type=style&index=0&id=a853b520&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a853b520",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VBtn,VFlex,VIcon,VTextField})
